import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './RootErrorBoundary.css';
import { useLocation, useRouteError } from 'react-router-dom';
import { useLogger } from '../../../';
import { ResponseError } from '@sgi/gravity/ResponseError';
import { Typography } from '@sgi/gravity/Typography';
export function RootErrorBoundary() {
    const error = useRouteError();
    const location = useLocation();
    const logger = useLogger();
    logger.error(`[shell] An unmanaged error occured while rendering the route with path ${location.pathname}`, error);
    const displayError = () => {
        const errorDetails = error.cause;
        if (errorDetails?.data || errorDetails?.errorCode || errorDetails?.description) {
            return (_jsxs(ResponseError, { errorCode: errorDetails.errorCode, errorDescription: errorDetails.description, title: "Something went wrong!", children: [_jsx(Typography, { children: errorDetails.description }), typeof errorDetails.data === 'object' ? _jsx("pre", { children: JSON.stringify(errorDetails.data, null, 1) }) : errorDetails.data, ";"] }));
        }
        else if (error?.stack) {
            return _jsx(Typography, { children: error.stack });
        }
        return _jsx(Typography, { children: "An error has occurred" });
    };
    return displayError();
}
